import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../../Common/InputText';
import { Editor } from 'react-draft-wysiwyg';


export const UserAccessSection = (props) => {

    let toolbar = {
        options: ['inline', 'fontSize', 'fontFamily', 'textAlign', 'colorPicker', 'link', 'emoji'],
        inline: {
            options: ['bold', 'italic', 'underline']
        }
    };

    const onChange = (e) => {
        props.onFormChange(e.target.name, e.target.value);
    }
    
    const className = props.isFormValid ? "user-access-form" : "user-access-form was-validated"
    return (
        <div className="user-access-section section">
            <form className={className} noValidate>
                <div className="row content">
                    <div className="col-12 col-md-4 header">
                        <h4>User Access</h4>
                        <p>The secret code your colleagues will use to request access to Pacer and the information/messages that you want to share with your colleagues when they become a user in Pacer.</p>
                    </div>
                    <div className="col-12 col-md-8 fields">
                        <div className="row">
                            <InputText name="accessCode" label="User Request Access Code" type="text" placeholder="User Request Access Code" 
                                onChange={onChange} value={props.subscription.accessCode} isRequired={true} 
                                errorMessage="User Request Access Code is required" bootstrapClass="col-12" />
                            {!props.isAccessCodeFormValid && !props.isFormValid &&
                                <p className="accessCodeRules">Access code must contain at least 1 letter, 1 number or special character, and be at least 7 characters long. </p>
                            }
                            {!props.isAccessCodeResponseValid &&
                                <p className="accessCodeRules">Access code cannot be a common password</p>
                            }
                        </div>
                        <div className="row mt-3">
                            <strong>New User Approved Email Message</strong>
                        </div>
                        <div className="row">
                            <div>
                                <Editor
                                    spellCheck={true}
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    toolbar={toolbar}
                                    onEditorStateChange={props.onApprovedMessageChange}
                                    editorState={props.approvedMessageEditorState}
                                />
                            </div>
                            {props.showApprovedMessageRequired && !props.isFormValid  &&
                                <div name="showApprovedMessageRequired" className="text-danger">User Approved Message is required.</div>
                            }
                            <br />
                        </div>
                        <div className="row mt-3">
                            <strong>New User Invitation Email Message</strong>
                        </div>
                        <div className="row">
                            <div>
                                <Editor
                                    spellCheck={true}
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                    toolbar={toolbar}
                                    onEditorStateChange={props.onEmailMessageChange}
                                    editorState={props.emailMessageEditorState}
                                />
                            </div>
                            {props.showUserInviteMessageRequired && !props.isFormValid  &&
                                <div name="showUserInviteMessageRequired" className="text-danger">User Invitation Email is required.</div>
                            }
                            <br />
                        </div>
                        <div className="row mt-3">
                            <InputText name="reportPageFooter" label="Report Page Footer" type="text" placeholder="Report Page Footer" 
                                onChange={onChange} value={props.subscription.reportPageFooter} bootstrapClass="col-12" />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

UserAccessSection.propTypes = {
    subscription: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    onFormChange: PropTypes.func.isRequired,
    onEmailMessageChange: PropTypes.func.isRequired,
    onApprovedMessageChange: PropTypes.func.isRequired,
    showUserInviteMessageRequired: PropTypes.bool.isRequired,
    showApprovedMessageRequired: PropTypes.bool.isRequired,
    isAccessCodeFormValid: PropTypes.bool.isRequired,
    isAccessCodeResponseValid: PropTypes.bool.isRequired,
    approvedMessageEditorState: PropTypes.object,
    emailMessageEditorState: PropTypes.object
};


export default UserAccessSection;

